import type { IconDictionary, IconCategoriesDictionary } from './manager';

export type FontAwesomeData = {
  icons: IconDictionary;
  categories: IconCategoriesDictionary;
};

export const loadFontAwesomeData = async (): Promise<FontAwesomeData> => {
  const iconModule = await import('./fontAwesomeData.json');
  return iconModule.default as unknown as FontAwesomeData;
};
